import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export async function uploadHolidaySheet(file: File): Promise<void> {
  const formData = new FormData();
  formData.append('file', file);

  return axios.post(`${API_URL}/api/load-holidays/`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}
